import { Link } from "react-router-dom";
import { Instagram, Youtube } from "lucide-react";
import NewsletterSignup from "./NewsletterSignup";

export default function Footer() {
  return (
    <footer className="bg-ocean text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid md:grid-cols-5 gap-12 mb-16">
          <div className="md:col-span-1">
            <div className="mb-4">
              <img
                src="/justjjax-logo-transparent.png"
                alt="justjjax"
                className="h-12 object-contain brightness-0 invert"
              />
            </div>
            <p className="text-white/60 text-sm leading-relaxed">
              Be the Vibe — holistic hair, wellness and community from Cornwall with love.
            </p>
          </div>

          <div>
            <h4 className="font-medium text-sm uppercase tracking-wider mb-4 text-white/40">Explore</h4>
            <div className="flex flex-col gap-3">
              <Link to="/about" className="text-white/70 hover:text-white transition-colors text-sm" data-testid="footer-about">About</Link>
              <Link to="/hair" className="text-white/70 hover:text-white transition-colors text-sm" data-testid="footer-hair">Hair & Massage</Link>
              <Link to="/products" className="text-white/70 hover:text-white transition-colors text-sm" data-testid="footer-shop">Shop</Link>
              <Link to="/clothing" className="text-white/70 hover:text-white transition-colors text-sm" data-testid="footer-clothing">Clothing</Link>
              <Link to="/high-on-life" className="text-white/70 hover:text-white transition-colors text-sm" data-testid="footer-blog">High on Life</Link>
            </div>
          </div>

          <div>
            <h4 className="font-medium text-sm uppercase tracking-wider mb-4 text-white/40">Connect</h4>
            <div className="flex flex-col gap-3">
              <Link to="/community" className="text-white/70 hover:text-white transition-colors text-sm" data-testid="footer-community">Community & Events</Link>
              <Link to="/surfers-against-sewage" className="text-white/70 hover:text-white transition-colors text-sm" data-testid="footer-sas">Surfers Against Sewage</Link>
              <Link to="/work-with-me" className="text-white/70 hover:text-white transition-colors text-sm" data-testid="footer-work">Work With Me</Link>
              <a href="https://tinyurl.com/2nxodcgu" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors text-sm" data-testid="footer-booking">Book a Session</a>
            </div>
          </div>

          <div>
            <h4 className="font-medium text-sm uppercase tracking-wider mb-4 text-white/40">Customer Information</h4>
            <div className="flex flex-col gap-3">
              <Link to="/delivery" className="text-white/70 hover:text-white transition-colors text-sm" data-testid="footer-delivery">Delivery</Link>
              <Link to="/returns" className="text-white/70 hover:text-white transition-colors text-sm" data-testid="footer-returns">Returns</Link>
              <Link to="/faqs" className="text-white/70 hover:text-white transition-colors text-sm" data-testid="footer-faqs">FAQs</Link>
              <Link to="/privacy" className="text-white/70 hover:text-white transition-colors text-sm" data-testid="footer-privacy">Privacy Policy</Link>
              <Link to="/terms" className="text-white/70 hover:text-white transition-colors text-sm" data-testid="footer-terms">Terms & Conditions</Link>
            </div>
          </div>

          <div>
            <h4 className="font-medium text-sm uppercase tracking-wider mb-4 text-white/40">Stay in the loop</h4>
            <NewsletterSignup variant="dark" />
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs">&copy; 2026 Justjjax. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <a href="https://www.instagram.com/justjjax/" target="_blank" rel="noopener noreferrer" className="text-white/40 hover:text-white transition-colors" data-testid="footer-instagram">
              <Instagram size={18} />
            </a>
            <a href="https://www.facebook.com/profile.php?id=61550018370626" target="_blank" rel="noopener noreferrer" className="text-white/40 hover:text-white transition-colors" data-testid="footer-facebook">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
            </a>
            <span className="text-white/25 cursor-default" data-testid="footer-youtube" title="YouTube — coming soon">
              <Youtube size={18} />
            </span>
            <a href="https://tiktok.com/@Just_jjax" target="_blank" rel="noopener noreferrer" className="text-white/40 hover:text-white transition-colors" data-testid="footer-tiktok">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.88-2.88 2.89 2.89 0 012.88-2.88c.3 0 .59.05.86.12V9.01a6.32 6.32 0 00-.86-.06 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.34-6.34V8.75a8.28 8.28 0 004.76 1.5V6.8a4.84 4.84 0 01-1-.11z"/></svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
